export default __webpack_public_path__ + "static/media/invoice_chart.8f38d5fc.svg";